import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dollarValuePipe' })
export class DollarValuePipe implements PipeTransform {
    transform(value: number, args: any = {}): any {
            return (Math.round(value * 100000) / 100);
    }
}
